/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import { ModalScrollScreen } from '../../../shared/layout/ModalScrollScreen'
import { useContentLayout } from '../../../shared/layout/useContentLayout';
import { useShellScreenHeaderRefresh } from '../../navigation/TabScreenRefreshContext';
import { SupportTicketDetailPanel } from '../components/SupportTicketDetailPanel';

export const SupportTicketDetailScreen = () => {
  const navigation = useNavigation<any>();
  const route = useRoute() as { params?: { ticketId?: string } };
  const ticketId = route.params?.ticketId ?? '';
  const { layoutWebShell } = useContentLayout('settingsWide');
  const reloadRef = useRef<(() => Promise<void>) | null>(null);
  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    try {
      await reloadRef.current?.();
    } finally {
      setRefreshing(false);
    }
  }, []);

  useShellScreenHeaderRefresh('SupportTicketDetail', onRefresh);

  useEffect(() => {
    if (layoutWebShell && ticketId) {
      navigation.navigate('MainTabs', { screen: 'SupportReports', params: { ticketId } });
    }
  }, [layoutWebShell, ticketId, navigation]);

  if (layoutWebShell) {
    // BUG-016: No renderizar spinner en web — la redirección es inmediata.
    return null;
  }

  return (
    <ModalScrollScreen
      variant="settingsWide"
      contentContainerStyle={{ padding: 0 }}
      keyboardShouldPersistTaps="handled"
      refreshing={refreshing}
      onRefresh={onRefresh}
    >
      <SupportTicketDetailPanel
        ticketId={ticketId}
        scrollable={false}
        onRegisterReload={(reload) => {
          reloadRef.current = reload;
        }}
      />
    </ModalScrollScreen>
  );
};
